<template>
  <div class="shared-news">
    <div class="shared-news-title">
      <h3 class="text-accent">{{ $t('kcm-group') }}</h3>
      <h1>{{ $t('shared-news-1') }}</h1>
    </div>
    <div class="news-container">
      <template v-for="(n) in news">
        <div class="news-item" :key="n._id" @click="goTo(n._id)">
          <div class="news-img" :style="{ backgroundImage: `url('${path}/${n.cover}')`}"></div>
          <div class="text-group">
            <h3 class="text-accent">{{ n.date | formatDateDot }} &#124; {{ n[$i18n.locale].label }}</h3>
            <h2>{{ n[$i18n.locale].title }}</h2>
            <p>{{ (n[$i18n.locale].subtitle).substr(0, 80) }}...</p>
            <router-link :to="`/news?id=${n._id}`" class="link">
              <span class="text-main-home">{{ $t('shared-news-2') }}</span>
            </router-link>
          </div>
        </div>
      </template>
    </div>
    <div class="news-link-wrapper">
      <router-link to="/news" class="link-wrapper">
        <span class="link">
          <span class="text-light">{{ $t('shared-news-3') }}</span>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: process.env.VUE_APP_UPLOADS_URI,
      news: []
    };
  },
  watch: {
    $route() {
      this.getNews();
    },
    '$i18n.locale'() {
      this.getNews();
    }
  },
  methods: {
    goTo(id) {
      this.$router.push(`/news?id=${id}`);
    },
    getNews() {
      let url = `${process.env.VUE_APP_BASE_URI}/news?size=2`;

      if (this.$route.query.id) {
        url += `&ignore=${this.$route.query.id}`;
      }

      if (this.$i18n.locale === 'en') {
        url += '&en=true';
      }

      this.$http
        .get(url)
        .then(result => {
          this.news = result.data.news;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getNews();
  }
};
</script>

<style lang="scss" scoped>
$newsItemBg: rgba(178, 200, 210, 0.3);
$newsItemHeight: 350px;
$newsItemHeight1376: 250px;
$sidesPaddingCut: $sidesPadding - 20px;
$sidesPaddingCut1600: $sidesPadding1600 - 20px;
$sidesPaddingCut1280: $sidesPadding1280 - 20px;
$textGroupPadding: 25px;

.shared-news {
  overflow: hidden;
  width: 100%;
}
.shared-news-title {
  padding: 100px $sidesPadding;
}
.news-container {
  @extend %flex-center;
  padding: 0 $sidesPaddingCut;
}
.news-item {
  @extend %flex-center;
  background-color: $newsItemBg;
  justify-content: flex-end;
  position: relative;
  width: 50%;
  .news-img {
    background-size: cover;
    background-position: center;
    display: block;
    height: 120%;
    left: 20px;
    position: absolute;
    top: -10%;
    @include transition(all 0.6s $mainCubic);
    width: 30%;
  }
  .text-group {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    height: $newsItemHeight;
    justify-content: center;
    padding: $textGroupPadding;
    position: relative;
    width: 66.66%;
    z-index: 1;
    p {
      opacity: 0.7;
    }
    h2,
    h3,
    p,
    .link {
      position: relative;
      @include transition(all 0.6s $mainCubic);
      z-index: 1;
    }
    // FOR IE
    h2,
    h3,
    p {
      width: 100%;
    }
  }
  .text-group::after {
    content: '';
    background-color: $mainColor;
    height: calc(100% - 50px);
    position: absolute;
    right: -10%;
    opacity: 0;
    top: $textGroupPadding;
    @include transition(all 0.6s $mainCubic);
    @include transform(translateX(10%));
    width: 0;
  }
}
.news-item:first-of-type::before {
  border-color: transparent $newsItemBg transparent transparent;
  border-style: solid;
  border-width: 0 $sidesPaddingCut $newsItemHeight 0;
  content: '';
  height: 0;
  left: -$sidesPaddingCut;
  position: absolute;
  top: 0;
  width: 0;
}
.news-item:last-of-type::before {
  border-color: transparent transparent transparent $newsItemBg;
  border-style: solid;
  border-width: $newsItemHeight 0 0 $sidesPaddingCut;
  content: '';
  height: 0;
  right: -$sidesPaddingCut;
  position: absolute;
  top: 0;
  width: 0;
}
.news-item:hover {
  .news-img {
    width: 75%;
  }
  .text-group {
    h2,
    p,
    .link span {
      color: $mainTextLight;
    }
  }
  .text-group::after {
    width: 110%;
    opacity: 1;
    @include transform(translateX(0));
  }
}
.news-link-wrapper {
  @extend %flex-center;
  justify-content: flex-end;
  .link-wrapper {
    background-color: $mainColor;
    .link::before {
      background-color: $mainTextLight;
    }
  }
}
@media screen and (max-width: 1600px) {
  .shared-news-title {
    padding: 100px $sidesPadding1600;
  }
  .news-container {
    padding: 0 $sidesPaddingCut1600;
  }
  .news-item:first-of-type::before {
    border-width: 0 $sidesPaddingCut1600 $newsItemHeight 0;
    left: -$sidesPaddingCut1600;
  }
  .news-item:last-of-type::before {
    border-width: $newsItemHeight 0 0 $sidesPaddingCut1600;
    right: -$sidesPaddingCut1600;
  }
}
@media screen and (max-width: 1376px) {
  .shared-news-title {
    padding: 60px $sidesPadding1600;
  }
  .news-item {
    .text-group {
      height: $newsItemHeight1376;
    }
  }
  .news-item:first-of-type::before {
    border-width: 0 $sidesPaddingCut1600 $newsItemHeight1376 0;
  }
  .news-item:last-of-type::before {
    border-width: $newsItemHeight1376 0 0 $sidesPaddingCut1600;
  }
}
@media screen and (max-width: 1280px) {
  .shared-news-title {
    padding: 60px $sidesPadding1280;
  }
  .news-container {
    padding: 0 $sidesPaddingCut1280;
  }
  .news-item {
    .text-group {
      height: $newsItemHeight1376;
    }
  }
  .news-item:first-of-type::before {
    border-width: 0 $sidesPaddingCut1280 $newsItemHeight1376 0;
    left: -$sidesPaddingCut1280;
  }
  .news-item:last-of-type::before {
    border-width: $newsItemHeight1376 0 0 $sidesPaddingCut1280;
    right: -$sidesPaddingCut1280;
  }
}
@media screen and (max-width: 1280px) {
  .shared-news-title {
    padding: 40px $sidesPadding1280;
  }
}
@media screen and (max-width: 1000px) {
  .shared-news {
    position: relative;
  }
  .shared-news::before {
    background-color: #b2c8d2;
    content: '';
    height: 40%;
    opacity: 0.25;
    right: 0;
    position: absolute;
    top: 0;
    width: 35%;
  }
  .shared-news::after {
    background-color: #b2c8d2;
    bottom: 0;
    content: '';
    height: 60%;
    opacity: 0.25;
    left: 0;
    position: absolute;
    width: 65%;
  }
  .shared-news-title {
    position: relative;
    z-index: 1;
  }
  .news-container {
    padding: 0;
    align-items: stretch;
    justify-content: flex-start;
    position: relative;
    z-index: 1;
  }
  .news-item {
    align-items: flex-start;
    background-color: #fff;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 5%;
    width: 45%;
    .news-img {
      background-size: cover;
      background-position: center;
      display: block;
      height: 30vw;
      left: 5%;
      top: -20px;
      position: relative;
      @include transition(all 0.6s $mainCubic);
      width: 100%;
    }
    .text-group {
      height: initial;
      padding-top: 0;
      width: 100%;
      p,
      h3 {
        display: none;
      }
      h2 {
        margin-top: 0;
      }
    }
  }
  .news-item:first-of-type::before,
  .news-item:last-of-type::before {
    display: none;
  }
  .news-item:hover {
    .news-img {
      width: 100%;
    }
    .text-group {
      h2,
      .link span {
        color: $mainColor;
      }
      .link:hover span {
        color: #fff;
      }
    }
    .text-group::after {
      display: none;
    }
  }
  .news-link-wrapper {
    margin-top: 20px;
    position: relative;
    z-index: 1;
    .link-wrapper {
      background-color: $mainColor;
      display: flex;
      justify-content: center;
      padding: 30px 50px 20px;
      width: 100%;
      .link {
        position: relative;
      }
      .link::before {
        background-color: $mainTextLight;
        display: block;
      }
    }
    .link-wrapper::before {
      display: none;
    }
  }
  .link-wrapper:hover {
    .link {
      span {
        color: #fff;
      }
    }
    .link::before {
      height: 2px;
      left: 0;
      width: 100%;
    }
  }
  .news-link-wrapper:hover {
    opacity: 0.8;
  }
}
@media screen and (max-width: 600px) {
  .shared-news-title {
    padding: 20px $sidesPadding600 40px;
  }
}
</style>
